import { c as i } from "../../../index-34b1f277.js";
const { defineMultiStyleConfig: e, definePartsStyle: n } = i([
  "container",
  "containerWithIcon",
  "isInitialContainer",
  "label"
]), a = n({
  label: {
    color: "primary.700",
    noOfLines: 1
  },
  container: {
    alignItems: "center",
    borderRadius: "radius-400",
    display: "flex",
    height: "fit-content",
    justifyContent: "center",
    width: "max-content",
    svg: {
      color: "primary.700"
    }
  }
}), o = {
  md: {
    label: {
      paddingX: "spacing-50",
      fontSize: "lg"
    },
    container: {
      height: "size-400",
      paddingX: "spacing-125",
      svg: {
        boxSize: 4
      }
    },
    containerWithIcon: {
      paddingLeft: "spacing-100"
    },
    isInitialContainer: {
      padding: 0,
      boxSize: 8
    }
  },
  sm: {
    label: {
      paddingX: "spacing-50",
      fontSize: "sm"
    },
    container: {
      height: "size-300",
      paddingX: "spacing-100",
      svg: {
        boxSize: 3
      }
    },
    containerWithIcon: {
      paddingLeft: "spacing-50"
    },
    isInitialContainer: {
      padding: 0,
      boxSize: 6
    }
  },
  xs: {
    label: {
      paddingX: "spacing-25",
      fontSize: "2xs"
    },
    container: {
      height: "size-200",
      paddingX: "spacing-75",
      svg: {
        boxSize: 2.5
      }
    },
    containerWithIcon: {
      paddingLeft: "spacing-50"
    },
    isInitialContainer: {
      padding: 0,
      boxSize: 4
    }
  }
}, t = {
  primary: n({
    container: {
      backgroundColor: "primary.50"
    }
  }),
  secondary: n({
    container: {
      backgroundColor: "secondary.50"
    }
  }),
  tertiary: n({
    container: {
      backgroundColor: "tertiary.100"
    }
  }),
  accent: n({
    container: {
      backgroundColor: "beige.200"
    }
  }),
  info: n({
    container: {
      backgroundColor: "lightBlue.200"
    }
  }),
  success: n({
    container: {
      backgroundColor: "success.100"
    }
  }),
  danger: n({
    container: {
      backgroundColor: "error.100"
    }
  })
}, c = e({
  baseStyle: a,
  sizes: o,
  variants: t,
  defaultProps: {
    size: "md",
    variant: "primary"
  }
});
export {
  c as Badge
};
//# sourceMappingURL=Badge.es.js.map
